import React from 'react'
import { Link } from 'react-router-dom'

import img1 from '../../Images/1 (1).webp'
import img2 from '../../Images/1 (2).webp'
import img3 from '../../Images/1 (1).webp'


import preimg1 from '../../Images/col_icon1.webp'
import preimg2 from '../../Images/col_icon2.webp'
import preimg3 from '../../Images/col_icon3.webp'
import preimg4 from '../../Images/col_icon4.webp'
import preimg5 from '../../Images/col_icon5.webp'
import preimg6 from '../../Images/col_icon6.webp'
import preimg7 from '../../Images/col_logo4.webp'
import preimg8 from '../../Images/col_logo5.webp'
import preimg9 from '../../Images/col_logo6.webp'



const cardData = [
    {
        id: 1,
        imgSrc: preimg1,
        title: "JEE Main 2025 College Predictor",
        rankings: [
            "📅 Exam Date: 02 Apr 25 - 09 Apr 25",
            "📝 Application Form: 01 Feb 25 - 25 Feb 25",
            "📢 Result Announce: 12 Apr 25"
        ],
        linkText: "Apply Now"
    },
    {
        id: 2,
        imgSrc: preimg2,
        title: "NEET UG 2025 College Predictor",
        rankings: [
            "📅 Exam Date: 05 May 25",
            "📝 Application Form: 01 Mar 25 - 31 Mar 25",
            "📢 Result Announce: 20 Jun 25"
        ],
        linkText: "Apply Now"
    },
    {
        id: 3,
        imgSrc: preimg3,
        title: "GATE 2025 College Predictor",
        rankings: [
            "📅 Exam Date: 03 Feb 25 - 11 Feb 25",
            "📝 Application Form: 24 Aug 24 - 30 Sep 24",
            "📢 Result Announce: 16 Mar 25"
        ],
        inkText: "Apply Now"
    },
    {
        id: 4,
        imgSrc: preimg4,
        title: "CAT 2025 College Predictor",
        rankings: [
            "📅 Exam Date: 24 Nov 25",
            "📝 Application Form: 02 Aug 25 - 15 Sep 25",
            "📢 Result Announce: 15 Jan 26"
        ],
        nkText: "Apply Now"
    },
    {
        id: 5,
        imgSrc: preimg5,
        title: "CLAT 2025 College Predictor",
        rankings: [
            "📅 Exam Date: 01 Dec 24",
            "📝 Application Form: 01 Jul 24 - 03 Nov 24",
            "📢 Result Announce: 25 Dec 24"
        ],
        inkText: "Apply Now"
    },
    {
        id: 6,
        imgSrc: preimg6,
        title: "UPSC CSE 2025 College Predictor",
        rankings: [
            "📅 Prelims: 26 May 25",
            "📝 Application Form: 01 Feb 25 - 21 Feb 25",
            "📢 Result Announce: 01 May 25"
        ],
        linkText: "Apply Now"
    },
    {
        id: 7,
        imgSrc: preimg7,
        title: "BITSAT 2025 College Predictor",
        rankings: [
            "📅 Exam Date: 22 May 25 - 26 May 25",
            "📝 Application Form: 10 Jan 25 - 10 Apr 25",
            "📢 Result Announce: 15 Jun 25"
        ],
        linkText: "Apply Now"
    },
    {
        id: 8,
        imgSrc: preimg8,
        title: "XAT 2025 College Predictor",
        rankings: [
            "📅 Exam Date: 05 Jan 25",
            "📝 Application Form: 15 Jul 24 - 30 Nov 24",
            "📢 Result Announce: 20 Jan 25"
        ],
        nkText: "Apply Now"
    },
    {
        id: 9,
        imgSrc: preimg9,
        title: "SRMJEEE 2025 College Predictor",
        rankings: [
            "📅 Exam Date: 15 Apr 25 - 20 Apr 25",
            "📝 Application Form: 01 Dec 24 - 31 Mar 25",
            "📢 Result Announce: 01 May 25"
        ],
        linkText: "Apply Now"
    },
];


const Collegepre = () => {
    return (
        <div className="bg-gray-50 min-h-screen pb-20">
            {/* Banner */}
            <div className="bg-gradient-to-r from-purple-900 via-purple-800 to-purple-900 text-white py-20 text-center shadow-lg relative overflow-hidden">
                <div className="absolute inset-0 bg-white opacity-5 pattern-grid-lg"></div>
                <div className="container mx-auto px-4 relative z-10">
                    <h1 className="text-4xl md:text-5xl font-bold mb-4">College Predictor 2025</h1>
                    <p className="text-purple-100 max-w-3xl mx-auto text-lg leading-relaxed">
                        Top Universities & Exams – Get Your Admission Insights. Explore the Top Colleges in India for 2025!
                    </p>
                </div>
            </div>

            <div className="container mx-auto px-4 mt-8">
                {/* Breadcrumb & Title */}
                <div className="flex items-center gap-2 text-sm text-gray-500 mb-6">
                    <Link to="/" className="hover:text-brand-orange transition"><i className='fa fa-home text-lg'></i></Link>
                    <span>/</span>
                    <span className="font-semibold text-gray-700">Predictor</span>
                </div>

                <div className="mb-8 pl-4 border-l-4 border-purple-500">
                    <h3 className="text-2xl font-bold text-gray-800">
                        Top Universities & Exams – Get Your Admission Insights
                    </h3>
                </div>

                {/* Featured Images */}
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-16">
                    {[img1, img2, img3].map((img, index) => (
                        <div key={index} className="rounded-2xl overflow-hidden shadow-md border border-gray-200 hover:shadow-xl transition-all duration-300 group">
                            <div className="h-48 overflow-hidden">
                                <img src={img} alt="Predictor Highlight" className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" />
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {/* Entrance Exams Grid */}
            <div className="container mx-auto px-4 mb-16">
                <div className="text-center mb-12">
                    <h2 className="text-3xl font-bold text-gray-800 uppercase">Entrance Exams In India</h2>
                    <div className="w-24 h-1 bg-brand-orange mx-auto mt-4 rounded-full"></div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                    {cardData.map((card) => (
                        <div key={card.id} className="group h-full">
                            <div className="bg-white border border-gray-200 rounded-3xl overflow-hidden shadow-sm hover:shadow-xl hover:border-purple-300 transition-all duration-300 h-full flex flex-col">
                                <div className="bg-purple-50 p-6 flex items-center justify-center border-b border-gray-100 group-hover:bg-purple-100 transition-colors">
                                    <img className="w-24 h-24 object-contain filter drop-shadow-sm group-hover:scale-110 transition-transform duration-300" src={card.imgSrc} alt={card.title} />
                                </div>

                                <div className="p-6 flex-grow flex flex-col">
                                    <h5 className="text-lg font-bold text-gray-800 mb-4 text-center group-hover:text-purple-700 transition-colors">{card.title}</h5>

                                    <ul className="space-y-3 mb-6 flex-grow">
                                        {card.rankings.map((rank, index) => (
                                            <li key={index} className="text-sm text-gray-600 flex items-start gap-2 bg-gray-50 p-2 rounded-lg border border-gray-100">
                                                <span className="flex-shrink-0 mt-0.5">{rank.split(':')[0]}:</span>
                                                <span className="font-semibold text-gray-800">{rank.split(':')[1]}</span>
                                            </li>
                                        ))}
                                    </ul>

                                    <Link to="/contact" className="block w-full text-center bg-white border border-purple-500 text-purple-600 font-bold py-3 rounded-xl hover:bg-purple-600 hover:text-white transition-all shadow-sm hover:shadow-md">
                                        Apply Now <i className="fa fa-angle-double-right ms-1"></i>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default Collegepre
